import React from 'react';

import { ErrorBoundary } from 'app/components/common/error-boundary';
import { loggerService } from 'app/service/logger-service';

import { FatalError } from './fatal-error';
import { FatalErrorType } from './fatal-error-type';

const Fallback: React.FC = () => <FatalError error={FatalErrorType.ERROR_OCCURRED} />;

const FatalErrorBoundary: React.FC = (props) => {
    const handleError = React.useCallback((error: Error, errorInfo: React.ErrorInfo) => {
        loggerService.error(error.name, error.message, error.stack, errorInfo.componentStack);
    }, []);

    return <ErrorBoundary {...props} fallback={Fallback} onError={handleError} />;
};

export { FatalErrorBoundary };
